import styled from 'styled-components';
import { DescriptionHyperLink as DescriptionHyperLinkCommon } from '../../ItemCommons';

export const DescriptionHyperLink = styled(DescriptionHyperLinkCommon)<{
  bottomMargin?: number;
  topMargin?: number;
}>`
  ${({ bottomMargin }) => `margin-bottom: ${bottomMargin}px`};
  ${({ topMargin }) => `margin-top: ${topMargin}px`};
`;

export const QuantityPriceWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
